<template>
	<div>
		<div v-if="multiple" class="input-wrapper" :class="{'input-wrapper-tooltip': tooltip, 'has-focus': has_focus || selected.length !== 0, 'has-error': error.length > 0}">
			<i v-if="icon" class="input-icon" :class="['fas', icon]"></i> 
			<div class="input-label" :class="{'has-icon': icon}">
				{{ label }} {{ required ? "*" : "" }}
			</div>
			<div class="input-element-div" :class="{'has-icon': icon}" @click="has_focus = true">
				<button v-for="(index, i) in selected" :key="i" class="input-element-selected" @click="unselect(index)">
					{{ (options[index].length > 10 ? options[index].slice(0, 10) + "..." : options[index]) }}
					<i class="fas fa-fw fa-times"></i>
				</button>
				<input v-model="search" class="search-element" autocomplete="none" type="hidden"
					:disabled="disabled"
					@input="filter" 
					@keydown.enter.prevent="select_first"
					@blur="trigger_blur" 
					@click="has_focus = true"

					ref="search_element"
				/>
			</div>
			<div class="input-error">
				{{ error }}
			</div>
		</div>
		<div v-else class="input-wrapper" :class="{'input-wrapper-tooltip': tooltip, 'has-focus': has_focus || selected.length !== 0, 'has-error': error.length > 0}">
			<i v-if="icon" class="input-icon" :class="['fas', icon]"></i> 
			<div class="input-label" :class="{'has-icon': icon}">
				{{ label }} {{ required ? "*" : "" }}
			</div>
			<input v-model="search" class="input-element" type="text" autocomplete="none"
				:class="{'has-icon': icon}"
				:disabled="disabled"
				@input="filter" 
				@keydown.enter.prevent="select_first" 
				@focus="has_focus = true" 
				@blur="trigger_blur" 
				
				ref="input_element"
			/>
			<div class="option-box" :class="{'show': has_focus}">
				<div v-for="(item, index) in options_display" :key="index" class="option-item" :class="{'selected': item.value == selected}" @click="select(item.value)" :title="item.label.toUpperCase()">
					{{ item.label.toUpperCase() }}
				</div>
			</div>
			<div class="input-error">
				{{ error }}
			</div>
		</div>
		<div v-if="tooltip" class="input-tooltip" v-popover:tooltip.left="tooltip">
			<i class="fas fa-question-circle"></i>
		</div>
		<Modal v-if="multiple && has_focus"
			title="SELECIONE"
			breakpoint="md"
			@close="has_focus = false"
			@save="has_focus = false"
			@blur="trigger_blur"
		>
			<div class="row">
				<div class="col-xs-12 col-lg-12 list-search">
					<FormInput v-model="search" label="Buscar" type="text" icon="fa-search" ref="search" @input="filter" />
				</div>
				<div class="col-xs-12 col-lg-12">
					<div class="row">
						<div class="col-xs-6 col-lg-2 list-label" @click="select_all()"><i :class="(selected.length == Object.keys(options).length) ? 'fas fa-fw fa-check-square' : 'far fa-fw fa-square'"></i> Opções</div>
						<div class="col-xs-6 col-lg-10 list-total">Selecionados: {{ selected.length }}</div>
					</div>
				</div>
				<div class="col-xs-12 col-lg-12">
					<div class="row">
						<div v-for="(item, index) in options_display" :key="index" class="col-xs-12 col-lg-6">
							<div class="option-item-multiple" :class="{'selected': selected.includes(item.value)}" :title="item.label.toUpperCase()" @click="select(item.value)">
								<i v-if="item.label != 'Carregando...'"  class="option-item-icon" :class="selected.includes(item.value) ? 'fas fa-fw fa-check-square' : 'far fa-fw fa-square'" ></i> 
								{{ (item.label.length > 35 ? item.label.toUpperCase().slice(0, 35) + "..." : item.label.toUpperCase()) }}
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>
	</div>
</template>

<script>
import Modal from "@/components/Modal";
import FormInput from "@/components/FormInput";

export default {
	name: "FormSelect",

	components: {
		Modal,
		FormInput,
	},

	props: {
		icon: {
			type: String,
			require: false,
			default: undefined,
		},
		label: {
			type: String,
			require: true,
		},
		options: {
			type: Object,
			require: true,
		},
		tooltip: {
			type: String,
			require: false,
		},
		value: {
			type: [Array, Number, Object, String],
			require: false,
			default: undefined,
		},
		multiple: {
			type: Boolean,
			require: false,
			default: false,
		},
		required: {
			type: Boolean,
			require: false,
			default: false,
		},
		disabled: {
			type: Boolean,
			require: false,
			default: false,
		},
		loading: {
			type: Boolean,
			require: false,
			default: false,
		},
	},

	data: function() {
		let selected = undefined;
		let search = "";
		let options_display = [];

		if (this.multiple === undefined || !this.multiple) {
			selected = "";
		} else {
			selected = [];
		}
		
		if (this.value !== undefined) {
			if (this.multiple === undefined || !this.multiple) {
				selected = this.value;
				search = this.options[selected];
			} else {
				if (Object.is(this.value)) {
					Object.keys(this.value).forEach(i => {
						if (this.options[i] !== undefined) {
							selected.push(i);
						}
					});
				} else if (Array.isArray(this.value)) {
					this.value.forEach(i => {
						if (this.options[i] !== undefined) {
							selected.push(i);
						}
					});
				}
			}
		}
		
		if (!this.loading) {
			for (let index in this.options) {
				options_display.push({
					value: index,
					//label: (this.options[index].length > 65 ? this.options[index].slice(0, 62) + "..." : this.options[index]),
					label: this.options[index],
				});
			}
		} else {
			options_display.push({
				value: "",
				label: "Carregando...",
			});
		}

		return {
			search: search,
			selected: selected,
			options_display: options_display,
			has_focus: false,
			all_selected: true,
			error: "",
		}
	},

	methods: {
		filter: function() {
			let search_string =  this.search.toLowerCase();
			this.options_display = [];
			
			if (!this.loading) {
				if (search_string != "") {
					if (this.multiple === undefined || !this.multiple) {
						for (let index in this.options) {
							this.options_display.push({
								value: index,
								//label: (this.options[index].length > 65 ? this.options[index].slice(0, 62) + "..." : this.options[index]),
								label: this.options[index],
							});
						}
					} else {
						for (let index in this.options) {
							let value = index.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase();
							let label = this.options[index].toLowerCase();

							if (value.includes(search_string) || label.includes(search_string)) {
								this.options_display.push({
									value: index,
									//label: (this.options[index].length > 65 ? this.options[index].slice(0, 62) + "..." : this.options[index]),
									label: this.options[index],
								});
							}
						}
					}
				} else {
					for (let index in this.options) {
						this.options_display.push({
							value: index,
							//label: (this.options[index].length > 65 ? this.options[index].slice(0, 62) + "..." : this.options[index]),
							label: this.options[index],
						});
					}
				}

				if (search_string.length > 0) {
					if (this.options_display[0] !== undefined) {
						if (this.multiple === undefined || !this.multiple) {
							//this.selected = this.options_display[0].value;
						}
						this.$emit('input', this.selected);
					} else {
						if (this.multiple === undefined || !this.multiple) {
							this.selected = "";
						}
						this.$emit('input', this.selected);
					}
				} else {
					if (this.multiple === undefined || !this.multiple) {
						this.selected = "";
					}
					this.$emit('input', this.selected);
				}
			} else {
				this.options_display.push({
					value: "",
					label: "Carregando...",
				});
				this.$emit('input', this.selected);
			}
		},

		// Marca/Desmarca todos os registros
        select_all: function() {
            Object.keys(this.options).map(r => {
                let index = this.selected.findIndex(element => element == r);
                if (this.all_selected) {
                    if(index == -1) this.selected.push(r);
                } else {
                    if(index != -1) this.selected.splice(index, 1);
                }
            });
            this.all_selected = !this.all_selected;
			this.$emit('input', this.selected);
        },

		select: function(value) {
			if (this.options !== undefined && this.options[value] !== undefined) {
				if (this.multiple === undefined || !this.multiple) {
					if (this.selected != value) {
						this.selected = value;
						this.search = this.options[value];
						
					} else {
						this.selected = "";
						this.search = "";
					}
					this.$emit('input', this.selected);
					this.error = "";
				} else {
					if (!this.selected.includes(value)) {
						this.selected.push(value);
						this.search = "";
						this.$emit('input', this.selected);
						this.error = "";
					} else {
						let index = this.selected.indexOf(value);
						if (index !== false) {
							this.selected.splice(index, 1);
						}
						this.$emit('input', this.selected);

						if (this.selected.length == 0 && this.require) {
							this.error = "* " + this.label + " é obrigatório.";
						} else {
							this.error = "";
						}
					}
				}
				this.filter();
			} else {
				this.$emit('input', this.selected);
				this.error = "";
			}
		},
		
		unselect: function(value) {
			if (this.options[value] !== undefined) {
				if (this.multiple === undefined || !this.multiple) {
					if (this.selected == value) {
						this.selected = "";
						this.search = "";
						
					}
					this.$emit('input', this.selected);
					this.error = "";
				} else {
					if (this.selected.includes(value)) {
						let index = this.selected.indexOf(value);
						if (index !== false) {
							this.selected.splice(index, 1);
						}
						this.$emit('input', this.selected);

						if (this.selected.length == 0 && this.require) {
							this.error = "* " + this.label + " é obrigatório.";
						} else {
							this.error = "";
						}
					}
				}
			} else {
				this.$emit('input', this.selected);
				this.error = "";
			}
		},

		select_first: function() {
			this.select(this.options_display[0].value);
			this.$refs.input_element.blur();
		},

		trigger_blur: function() {
			if (this.multiple == undefined || !this.multiple) {
				if (this.options[this.selected] !== undefined) {
					this.search = this.options[this.selected];
				} else {
					this.search = "";
					if ((this.required !== undefined) && this.required) {
						this.error = "* " + this.label + " é obrigatório.";
					} else {
						this.error = "";
					}
				}
			} else {
				this.search = "";
				if ((this.selected.length == 0) && (this.required !== undefined) && this.required) {
					this.error = "* " + this.label + " é obrigatório.";
				} else {
					this.error = "";
				}
			}

			this.$emit('input', this.selected);

			if (!this.multiple) {
				setTimeout(() => { 
					this.has_focus = false;
				}, 100);
			}
		},

		clear_selected: function() {
			if (this.multiple === undefined || !this.multiple) {
				this.selected = "";
				this.search = "";
				this.$emit('input', this.selected);
			} else {
				this.selected.length = 0;
				this.search = "";
				this.$emit('input', this.selected);
			}

			// Atualiza Dom
			this.$forceUpdate();
		},
		
		validate: function() {
			if (this.required !== undefined && this.required) {
				if (this.$refs.input_element.value.length == 0) {
					this.error = this.label + " é obrigatório.";
					return;
				}
			}
			this.error = "";
		},
	}
}
</script>

<style scoped>
.input-wrapper {
	position: relative;
	width: 100%;
	height: 90px;
	color: #666;
	margin-bottom: 10px;
	display: inline;
	float: left;
}

.input-wrapper-tooltip {
	width: calc(100% - 20px);
}

.input-label {
	position: absolute;
	width: 100%;
	height: 25px;
	line-height: 30px;
	top: 25px;
	color: #999;
	transition: all 0.2s linear;
}

.has-focus .input-label {
	top: 0;
	left: 0 !important;
	font-size: 12px;
	color: #666;
}

.has-error .input-label {
	color: red;
}


.input-element {
	position: absolute;
	top: 20px;
	width: 100%;
	border: none;
	border-bottom: 1px solid #aaa;
	height: 40px;
	line-height: 40px;
	background: none;
}

.search-element {
	border: none;
	background: none;
	width: 100px;
}

.has-error .input-element {
	border-bottom: 1px solid red;
}

.input-element-div {
	position: absolute;
	top: 20px;
	width: 100%;
	border: none;
	border-bottom: 1px solid #aaa;
	height: 40px;
	line-height: 39px;
	background: none;
	overflow-x: auto;
	cursor: pointer;
}

.has-error .input-element-div {
	border-bottom: 1px solid red;
}
.input-element-selected {
	margin: .25rem .125rem;
	padding: 5px;
	background-color: #ccc;
	border: none;
	border-radius: 3px;
	font-size: 12px;
}

.input-error {
	width: 100%;
	position: absolute;
	top: 60px;
	font-size: 12px;
	height: 25px;
	line-height: 35px;
}

.has-error .input-error {
	color: red;
}

.option-box {
	width: 100%;
	max-height: 0;
	overflow: hidden;
	background: #fff;
	position: absolute;
	top: 60px;
	z-index: 2;
	transition: all 0.2s linear;
}

.option-box.show {
	height: auto;
	max-height: 150px;
	overflow: auto;
	border-left: 1px solid #ccc;
	border-right: 1px solid #ccc;
	border-bottom: 1px solid #ccc;
}

.option-item {
	font-size: 14px;
	font-weight: bold;
	width: 100%;
	height: 30px;
	line-height: 30px;
	padding-left: 10px;
	border-bottom: 1px solid #ddd;
	cursor: pointer;
	overflow-x: hidden;
	overflow-y: hidden;
}

.option-item-multiple {
	font-size: 14px;
	font-weight: bold;
	width: 100%;
	height: 30px;
	line-height: 30px;
	padding-left: 10px;
	border: 1px solid #ccc;
	border-radius: 4px;
    box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12) !important;
    margin-top: 5px;
	cursor: pointer;
	overflow-x: hidden;
	overflow-y: hidden;
	word-break: keep-all;
}

.option-item:hover,
.option-item-multiple:hover {
	opacity: 0.8;
}

.option-item.selected, 
.option-item-multiple.selected {
	background: #444;
	color: #fff;
}

.option-item-icon {
	padding-left: 5px;
}

.input-element.has-icon {
	padding-left: 40px;
}

.input-element-div.has-icon {
	padding-left: 40px;
}

.input-label.has-icon {
	left: 40px;
	width: calc(100% - 40px);
}

.input-icon {
	position: absolute;
	top: 18px;
	width: 40px;
	height: 40px;
	line-height: 40px;
	text-align: center;
	color: #666;
}

.has-error .input-icon {
	color: red;
}

.list-label,
.list-total {
	font-size: 14px;
	border-bottom: 1px solid #ccc;
	padding: 10px;
	margin-bottom: 10px;
}

.list-label {
	cursor: pointer;
}

.list-total {
	text-align: right;
}
</style>